<template>
  <div v-show="show">
    <footer
      class="footer-distributed"
      :style="{
        position: this.$route.name === 'guard' ? 'fixed' : '',
        height: this.$route.name === 'guard' ? '35px' : '',
      }"
    >
      <div class="footer-center">
        <a class="footer-link" :href="url">
          <span style="font-weight: 400">{{ footerText }}</span>
          <span
            class="footer-logo"
            :style="{
              background:
                'url(' + image + ') no-repeat center center / contain',
              'background-size': 'contain',
            }"
          />
        </a>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  computed: {
    url() {
      return this.$store.getters.whiteLabel.home_page_link
        ? this.$store.getters.whiteLabel.home_page_link
        : process.env.VUE_APP_LANGING_URL;
    },
    show() {
      if (window.location.hostname.includes("mushroommagnat")) {
        return false;
      }
      if (this.$store.getters.webviewGuard !== false) {
        return true;
      }
      if (this.$store.getters.showMadeViaDigarson) {
        return true;
      }
      if (
        this.$store.getters.whiteLabel.footerText ||
        this.$store.getters.whiteLabel.logo
      ) {
        return true;
      }
      return false;
    },
    footerText() {
      return this.$store.getters.whiteLabel.footerText
        ? this.$store.getters.whiteLabel.footerText
        : "Powered by";
    },
    image() {
      return this.$store.getters.whiteLabel.logo
        ? this.$store.getters.whiteLabel.logo
        : require("@/assets/img/digarson_logo.png");
    },
  },
};
</script>

<style scoped>
</style>
